import {CdExecutionProof} from '../../../interfaces/care/cd-execution-proof/cd-execution-proof';
import {LightCustomer} from '../../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../../customers/light-customer-factory';
import {CdCarePlan} from '../../../interfaces/care/cd-care-plan/cd-care-plan';
import {CdCarePlanFactory} from '../cd-care-plan/cd-care-plan-factory';
import {OpOperatingPlanItem} from '../../../interfaces/operating-plan/op-operating-plan-item';
import {LightEmployee} from '../../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../../employees/light-employee-factory';
import {LightUser} from '../../../interfaces/core/light-user';
import {LightUserFactory} from '../../core/light-user-factory';
import {CdEpTask} from '../../../interfaces/care/cd-execution-proof/cd-ep-task';
import {UserService} from '../../../services/core/user.service';
import {CdTemporaryMeasure} from '../../../interfaces/care/cd-execution-proof/cd-temporary-measure';
import {CdTemporaryMeasureFactory} from './cd-temporary-measure-factory';
import {CdEpTaskFactory} from './cd-ep-task-factory';

export class CdExecutionProofFactory {

  /**
   *
   * @param cdExecutionProof
   */
  public static fromObject(cdExecutionProof: any): CdExecutionProof {
    return new class implements CdExecutionProof {
      customer: LightCustomer =
        cdExecutionProof.customer ? LightCustomerFactory.fromObject(cdExecutionProof.customer) : null;
      customerId: number = cdExecutionProof.customer_id;
      cdCarePlan: CdCarePlan =
        cdExecutionProof.c_care_plan ? CdCarePlanFactory.fromObject(cdExecutionProof.c_care_plan) : null;
      cdCarePlanId: number = cdExecutionProof.c_care_plan_id;
      operatingPlanItem: OpOperatingPlanItem = cdExecutionProof.operating_plan_item;
      operatingPlanItemId: number = cdExecutionProof.operating_plan_item_id;
      employee: LightEmployee =
        cdExecutionProof.employee ? LightEmployeeFactory.fromObject(cdExecutionProof.employee) : null;
      employeeId: number = cdExecutionProof.employee_id;
      start: string = cdExecutionProof.start;
      end: string = cdExecutionProof.end;
      comment: string = cdExecutionProof.comment;
      user: LightUser = cdExecutionProof.user ? LightUserFactory.fromObject(cdExecutionProof.user) : null;
      userId: number = cdExecutionProof.user_id;
      cdEpTasks: CdEpTask[] =
        cdExecutionProof.c_ep_tasks ? CdEpTaskFactory.fromArray(cdExecutionProof.c_ep_tasks) : [];
      serviceId: number = cdExecutionProof.service_id;
      // Anything coming back from the backend is by definition a
      // finished DNW - drafts are kept locally only.
      isFinished: boolean = true;

      // ------------------------------------------------------------------------------------------------
      id: number = cdExecutionProof.id;
      uuid: string = cdExecutionProof.uuid;
      modified: string = cdExecutionProof.modified;
      created: string = cdExecutionProof.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param cdExecutionProofs
   */
  public static fromArray(cdExecutionProofs: any[]): CdExecutionProof[] {
    return cdExecutionProofs.map(_cdExecutionProof => CdExecutionProofFactory.fromObject(_cdExecutionProof));
  }

  /**
   *
   * @param cdExecutionProof
   */
  public static toRemote(cdExecutionProof: CdExecutionProof): any {
    return {
      id: cdExecutionProof.id,
      uuid: cdExecutionProof.uuid,
      modified: cdExecutionProof.modified,
      created: cdExecutionProof.created,
      customer_id: cdExecutionProof.customerId,
      c_care_plan_id: cdExecutionProof.cdCarePlanId,
      operating_plan_item_id: cdExecutionProof.operatingPlanItemId,
      employee_id: cdExecutionProof.employeeId,
      start: cdExecutionProof.start,
      end: cdExecutionProof.end,
      comment: cdExecutionProof.comment,
      service_id: cdExecutionProof.serviceId,
      tasks: CdEpTaskFactory.toArray(cdExecutionProof.cdEpTasks)
    };
  }

}
